// Local mirror of the five directions (also served by GET /api/directions).
// Only one direction remains in the build: THE MACHINE (served at "/").
export const DIRECTIONS = [
  {
    id: "six",
    slug: "/",
    number: "06",
    name: "THE MACHINE",
    tagline: "It does not suggest the work. It does the work.",
    palette: ["#07080A", "#151A22", "#5FE3A1", "#4C9AFF"],
  },
];

export const getDirection = (id) => DIRECTIONS.find((d) => d.id === id);

// Real, sourced credibility facts only. Nothing invented.
export const FACTS = [
  { value: "$100M+", label: "DTC revenue managed" },
  { value: "25+", label: "Ecommerce brands" },
  { value: "$50M+", label: "Paid media deployed" },
];

export const SURFACES = [
  { id: "storefront", label: "Storefront & merchandising" },
  { id: "lifecycle", label: "Lifecycle / email & SMS" },
  { id: "acquisition", label: "Paid acquisition" },
  { id: "creative", label: "Creative testing" },
  { id: "cro", label: "CRO & experimentation" },
  { id: "intelligence", label: "Reporting & intelligence" },
  { id: "operations", label: "Operations & follow-through" },
];

export const STACK_OPTIONS = [
  "Shopify", "Klaviyo", "Meta Ads", "Google Ads", "Amazon", "GA4",
  "Triple Whale", "Attentive", "Gorgias", "Slack", "Notion", "Sheets",
];

export const REVENUE_BANDS = ["Under $2M", "$2M – $5M", "$5M – $10M", "$10M – $25M", "$25M – $50M", "$50M+"];

export const AUTONOMY_LEVELS = [
  { id: "observe", label: "Observe only", blurb: "Watch and report. Zero write access." },
  { id: "recommend", label: "Recommend", blurb: "Rank the next moves with reasoning and evidence." },
  { id: "draft", label: "Draft", blurb: "Build the work, stop before anything ships." },
  { id: "approval", label: "Execute with approval", blurb: "Ship it the moment a human clears the gate." },
  { id: "autonomous", label: "Autonomous within limits", blurb: "Run unaided inside named budgets and blast radius." },
];
